module.exports = __webpack_public_path__ + "img/dept-4.a2082d1c.svg";